import {config} from "../config";
import {handleResponse} from "../helpers/response";
import {getsCartData, hideLoader, showLoader} from "./wishCompareCart";

export const UPDATE_CART_ITEM = 'UPDATE_CART_ITEM';

export function updateCartItem(act,item){
    return (dispatch, getState) => {
        dispatch(showLoader());
        const formData  = new FormData();
        formData.append("action", act);
        formData.append("good_id",item.productId);
        formData.append('count', item.count);
        formData.append('tok_', getState().user.userInfo._tok );
        var link = config.apiUrl + 'cart/update/';
        fetch(link, {method: 'POST', body: formData}).then(handleResponse).then(json => {
            dispatch(showLoader());
            dispatch(getsCartData());
            dispatch(hideLoader());
        })
    }
}

/**
 * Removes cart item
 *
 * @param item
 * @returns {function(...[*]=)}
 */
export function removeCartItem(item){
    return (dispatch, getState) => {
        dispatch(showLoader());
        var link = config.apiUrl + 'cart/update/';
        const formData  = new FormData();
        formData.append("action", 'removeAll');
        formData.append("good_id", item);
        formData.append('tok_', getState().user.userInfo._tok );
        fetch(link, {method: 'POST', body: formData}).then(handleResponse).then(json => {
            dispatch(showLoader());
            dispatch(getsCartData());
            dispatch(hideLoader());
        });
    }
}


